import React, { useEffect, useState } from "react";
import logo from "../../../../assets/logo.png";
import CertificateAzGen from "./CertificateAzuregen"; // Import the CertificateGen component
import "../Certificate.css";
import { fireDB } from "../../../../Backend/Firebase/FirebaseConfigData";
import { setDoc, doc } from "firebase/firestore";

const GenerateAzureCertificate = () => {
  const [name, setName] = useState("Student Name");
  const [fontSize, setFontSize] = useState("5xl");
  const [coursename, setcoursename] = useState(" Big Data Engineering on Azure Cloud");
  const [totalduration, settotalduration] = useState("4");
  const [completionmonth, setcompletionmonth] = useState("February");
  const [completionyear, setcompletionyear] = useState("2025");
  const [uid, setuid] = useState("12345-ABCDE-67890");
  const [currentDate, setCurrentDate] = useState(""); // Initialize as empty string
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [isSaved, setIsSaved] = useState(false); // State to track if data is saved

  // Function to generate a random alphanumeric string
  const generateRandomUID = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const length = 16; // Length of the random part after the date
    let result = "";

    // Get today's date in YYYYMMDD format (e.g., "20250208")
    const today = new Date();
    const datePart = today.toISOString().slice(0, 10).replace(/-/g, ""); // "YYYYMMDD"

    // Generate a random letter to start the UID
    const randomLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26)); // Random uppercase letter (A-Z)

    // Generate a random 9-character alphanumeric string
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    // Combine the random letter, the date part, and the random string to form the 16-character UID
    const uid = randomLetter + datePart + result;

    return uid;
  };

  // Use useEffect to generate and set the UID and currentDate when the component mounts
  useEffect(() => {
    const randomUID = generateRandomUID();
    setuid(randomUID);

    // Set today's date as the default current date
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10); // Format as "YYYY-MM-DD"
    setCurrentDate(formattedDate); // Set the default value of currentDate
  }, []);

  // Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true); // Set loading state to true

    try {
      // Save the form data to Firebase Firestore using the unique UID as the document ID
      await setDoc(doc(fireDB, "Certificates", uid), {
        name,
        coursename,
        totalduration,
        completionmonth,
        completionyear,
        uid,
        currentDate,
      });

      // Alert after data is stored successfully
      alert("Certificate data saved successfully!");

      // Set the state to indicate that the data has been saved
      setIsSaved(true);

      setTimeout(() => {
        // window.location.reload(); // Refresh page after a successful save
      }, 2000); // 2 seconds delay for user to see the success message
    } catch (e) {
      console.error("Error writing document: ", e);
      alert("Failed to save certificate data."); // Show error alert
    } finally {
      setIsLoading(false); // Set loading state to false after the operation
    }
  };

  // Handle date change
  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;
    setCurrentDate(selectedDate); // Update currentDate with the selected date
  };

  // Function to calculate font size based on name length
  const calculateFontSize = (name: string) => {
    const length = name.length;
    if (length <= 14) return "text-5xl";
    if (length <= 20) return "text-4xl";
    return "text-3xl";
  };

  // Update font size when name changes
  useEffect(() => {
    const newFontSize = calculateFontSize(name);
    setFontSize(newFontSize);
  }, [name]);

  return (
    <div className="min-h-screen bg-gradient-to-r from-white to-blue-50 py-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col lg:flex-row justify-between items-center mb-12">
        <div className="mb-6 lg:mb-0">
          <img src={logo} alt="Logo" className="h-20 w-auto object-contain" />
        </div>
        <div className="text-center mb-6 lg:mb-0">
          <h1 className="text-5xl font-extrabold text-gray-800">ForumDE Admin</h1>
        </div>
      </div>

      <hr className="border-t-4 border-gray-300 mb-14" />

      <h1 className="text-6xl font-bold text-center text-gray-700 mb-16">
        Generate Azure Certificate
      </h1>

      {/* Two Column Layout */}
      <div className="max-w-8xl px-6 sm:px-8 lg:px-12 grid grid-cols-1 lg:grid-cols-[4fr_8fr] gap-12">
        {/* Form Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <h2 className="text-3xl font-semibold text-gray-800 mb-8">Certificate Details</h2>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">Full Name</label>
              <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            <div>
              <label htmlFor="courseName" className="block text-sm font-medium text-gray-700 mb-2">Course Name</label>
              <input type="text" id="courseName" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={coursename} onChange={(e) => setcoursename(e.target.value)} />
            </div>

            <div>
              <label htmlFor="totalduration" className="block text-sm font-medium text-gray-700 mb-2">Total Duration in months</label>
              <input type="text" id="totalduration" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={totalduration} onChange={(e) => settotalduration(e.target.value)} />
            </div>

            <div>
              <label htmlFor="completionmonth" className="block text-sm font-medium text-gray-700 mb-2">Completion month</label>
              <select id="completionmonth" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={completionmonth} onChange={(e) => setcompletionmonth(e.target.value)}>
                <option value="January">January</option>
                <option value="February">February</option>
                <option value="March">March</option>
                <option value="April">April</option>
                <option value="May">May</option>
                <option value="June">June</option>
                <option value="July">July</option>
                <option value="August">August</option>
                <option value="September">September</option>
                <option value="October">October</option>
                <option value="November">November</option>
                <option value="December">December</option>
              </select>
            </div>

            <div>
              <label htmlFor="completionyear" className="block text-sm font-medium text-gray-700 mb-2">Completion year</label>
              <select id="completionyear" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={completionyear} onChange={(e) => setcompletionyear(e.target.value)}>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
              </select>
            </div>

            <div>
              <label htmlFor="uid" className="block text-sm font-medium text-gray-700 mb-2">Unique ID</label>
              <input type="text" id="uid" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={uid} onChange={(e) => setuid(e.target.value)}
              // readOnly
              />
            </div>

            <div>
              <label htmlFor="currentDate" className="block text-sm font-medium text-gray-700 mb-2">Current Date</label>
              <input
                type="date"
                id="currentDate"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={currentDate}
                onChange={handleDateChange}
              />
            </div>

            <button type="submit" className="w-full bg-blue-600 text-white font-semibold py-3 rounded-lg shadow-md hover:bg-blue-700 transition duration-300 ease-in-out">
              {isLoading ? "Saving..." : "Generate Certificate"}
            </button>
          </form>
        </div>

        {/* Preview Section */}
        <div className="bg-white rounded-2xl shadow-xl p-8 overflow-hidden">
          <h2 className="text-3xl font-semibold flex justify-center text-gray-800 mb-2">Certificate Preview</h2>
          <div className="w-full overflow-x-auto">
            <div className="w-[900px] mx-auto">
              <CertificateAzGen
                name={name}
                fontSize={fontSize}
                coursename={coursename}
                duration={totalduration}
                completionmonth={completionmonth}
                completionyear={completionyear}
                uid={uid}
                issueDate={currentDate}
                isSaved={isSaved} // Pass the isSaved state as a prop
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateAzureCertificate;